// @flow
import { map } from 'ramda';

import type { ParamsPOST } from 'app/common/components/Cafeteria/dataTypes/orderRequestSales/OrderRequestSale.types';

import type { Request } from '../../../index';


type UrlParams = {
  orderId: number | string,
}

type ApiParams = {
  change_id: number,
  customer_id: number,
  sales: Array<{
    guid: string,
    n: number,
  }>,
}

export const convertParams = ({
  orderId,
  changeId,
  customerId,
  orderItemsMap,
}: ParamsPOST): [ApiParams, UrlParams] => {
  const orderItems = Array.from(orderItemsMap.values());
  const urlParams: UrlParams = { orderId };
  const apiParams: ApiParams = {
    change_id: parseInt(changeId, 10),
    customer_id: parseInt(customerId, 10),
    sales: map(({ id, amount }) => ({
      guid: id,
      n: amount,
    }), orderItems),
  };

  return [apiParams, urlParams];
};

type ResultApi = "success"

export const POST_CAFETERIA_CUSTOMER_ORDERS_SALES: Request<
  ParamsPOST,
  ResultApi,
  UrlParams
> = [
  'cafeteria/customer/orders/{orderId}/sales',
  'post',
  ['data'],
];
